import {useMutation} from "@tanstack/react-query";
import client from '../../utils/Client'



// UPDATE A ROLE
const submit = (payload) => client.put('roles', payload);
export const useUpdateRole = (id,payload) => useMutation(['updateRole',id],() => submit(payload))